import { gql } from '../../../apollo/__generated__';

export const UPDATE_USER_CAUTION = gql(`
  mutation UpdateUserCaution($updateUserCautionInput: UpdateUserCautionInput!, $eventId: ID!) {
    updateUserCaution(updateUserCautionInput: $updateUserCautionInput) {
      id
      hasCaution(eventId: $eventId)
    }
  }
`);
